import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

// Turns a native <select> into a searchable dropdown. Re-initializes cleanly
// across Turbo Frame renders via connect/disconnect.
export default class extends Controller {
  connect() {
    this.select = new TomSelect(this.element, {
      maxOptions: null,
      placeholder: this.element.dataset.placeholder || "Search...",
      // Options can widen their search terms via data-keywords (e.g. the
      // project picker adds the client name there).
      searchField: ["text", "keywords"],
      onType: () => {
        // Drop the current selection the moment the user starts typing so the
        // search box isn't cluttered by the previously chosen option.
        if (this.select.items.length) this.select.clear(true)
      },
    })
  }

  disconnect() {
    this.select?.destroy()
  }
}
